import { render, staticRenderFns } from "./AppointmentsNotCreated.vue?vue&type=template&id=14cd3a21"
import script from "./AppointmentsNotCreated.vue?vue&type=script&lang=js"
export * from "./AppointmentsNotCreated.vue?vue&type=script&lang=js"
import style0 from "./AppointmentsNotCreated.vue?vue&type=style&index=0&id=14cd3a21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports